<template>
  <div>
    <PageAllow controller="ShopStockTakePlans" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color" v-show="!currentItemMode">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- +发布盘点计划单 -->
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click.stop="currentItemMode = 'new'"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("shopStockTakePlans.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 标题 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    v-model="options.title"
                    @text="KeyWord = $event"
                    :label="$t('shopStockTakePlans.title')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('shopStockTakePlans.status.title')"
                    :items="$consts.shopStockTakePlansStatus"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.cancel_flg"
                    :label="$t('shopStockTakePlans.cancel_flg.title')"
                    :items="$consts.shopStockTakePlansCancelFlg"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.over_flg"
                    :label="$t('shopStockTakePlans.over_flg.title')"
                    :items="$consts.shopStockTakePlansOverFlg"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="ShopStockTakePlans"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.created="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.term_date="{ item }">
            {{ item.term_date | formatTime }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('ShopStockTakePlans', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentItemMode = 'view';
                    currentItem = item;
                  "
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("shopStockTakePlans.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("shopStockTakePlans.detail") }}</span>
            </v-tooltip>

            <v-tooltip top v-if="item.actions.setting_shop">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    $router.push(
                      '/stock-take-orders/detail/stock-take-plans/shop-stock-take-plans/push-to-shop/' +
                        item.id
                    )
                  "
                >
                  {{
                    $t("shopStockTakePlans.setting_shop", [$consts.shopName()])
                  }}
                </v-btn>
              </template>
              <span>{{
                $t("shopStockTakePlans.setting_shop", [$consts.shopName()])
              }}</span>
            </v-tooltip>
            <!-- 编辑 -->
            <v-tooltip top v-if="item.actions.edit">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentItemMode = 'edit';
                    currentItem = item;
                  "
                >
                  {{ $t("shopStockTakePlans.edit") }}
                </v-btn>
              </template>
              <span>{{ $t("shopStockTakePlans.edit") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.actions.status_update">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="print"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentId = item.id;
                    statusUpdate();
                  "
                >
                  {{ $t("shopStockTakePlans.status_update") }}
                </v-btn>
              </template>
              <span>{{ $t("shopStockTakePlans.status_update") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.actions.cancel">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    delDialog = true;
                    currentId = item.id;
                  "
                >
                  {{ $t("shopStockTakePlans.delete") }}
                </v-btn>
              </template>
              <span>{{ $t("shopStockTakePlans.delete") }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | shopStockTakePlansColor"
              :text-color="item.status | shopStockTakePlansTextColor"
            >
              {{ item.status | shopStockTakePlansText }}
            </v-chip>
            <span class="text-no-wrap caption secondary--text">
              ({{
                item.over_flg
                  ? $t("shopStockTakePlans.over_flg.over_flg_true")
                  : $t("shopStockTakePlans.over_flg.over_flg_false")
              }})
            </span>
            <br />
            <v-chip
              v-if="item.cancel_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <v-dialog v-model="delDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="delDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("shopStockTakePlans.del_text") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="delDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="Del()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <shopStockTakePlansDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getShopStockTakePlansFromAPI()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import shopStockTakePlans from "@/api/shop_stock_take_plans";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import shopStockTakePlansDetail from "./plugins/Detail";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  title: "",
  status: [0, 1, 2],
  cancel_flg: [0],
  over_flg: [0, 1],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("shop_stock_take_plans-options")
        ? sessionStorage.getItem("shop_stock_take_plans-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    delDialog: false,
    currentItem: null,
    currentId: null,
    currentItemMode: null,
    ShopStockTakePlans: [],
  }),
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        replace: true,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stockTakeOrders"),
        disabled: false,
        href: "/stock-take-orders",
      },
      {
        text: i18n.t("shopStockTakePlans.objectName"),
        disabled: true,
        href: "",
      },
    ],

    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("shopStockTakePlans.date"),
      },
    ],

    headers() {
      var headers = [
        {
          text: i18n.t("shopStockTakePlans.Fields.title"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "title",
        },
        {
          text: i18n.t("shopStockTakePlans.Fields.total_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "counts.total_count",
        },
        {
          text: i18n.t("shopStockTakePlans.Fields.over_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "counts.over_count",
        },
        {
          text: i18n.t("shopStockTakePlans.Fields.un_over_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "counts.un_over_count",
        },
        {
          text: i18n.t("shopStockTakePlans.Fields.status"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "status",
          width: 162,
        },
        {
          text: i18n.t("shopStockTakePlans.Fields.created"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("shopStockTakePlans.Fields.term_date"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "term_date",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },

    ...mapState(["loading", "stickTableCols", "settings"]),
  },

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
    shopStockTakePlansDetail,
  },

  mounted() {
    this.$commonUtils.loadOptions("shop_stock_take_plans").then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
      }.bind(this)
    );
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        title: this.KeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getShopStockTakePlansFromAPI() {
      shopStockTakePlans.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.ShopStockTakePlans = response.data.shop_stock_take_plans;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    Del() {
      shopStockTakePlans.cancel(this.currentId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getShopStockTakePlansFromAPI();
          }
          this.delDialog = false;
        }.bind(this)
      );
    },
    statusUpdate() {
      shopStockTakePlans.statusUpdate(this.currentId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getShopStockTakePlansFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },

    options: {
      deep: true,
      handler() {
        this.getShopStockTakePlansFromAPI();
        sessionStorage.setItem(
          "shop_stock_take_plans-options",
          JSON.stringify(this.options)
        );
      },
    },
    settings: {
      immediate: true,
      handler() {
        this.getShopStockTakePlansFromAPI();
      },
    },
  },
};
</script>

<style>
</style>